import { useState } from "preact/hooks";
import { Redirect } from "wouter-preact";
import { signInWithProvider } from "../api/auth";
import { Disclaimer } from "../components/Disclaimer";
import { Wordmark } from "../components/Wordmark";
import { dismissAuthError, session } from "../state";

/**
 * The closed-beta wall (`/beta-full`).
 *
 * Reached when the sign-up cap refuses an account (`authError.betaFull`), but
 * safe to visit directly — the message then survives a reload or a shared link.
 * Nobody is signed in here: the gate rejects the account creation itself, so
 * there is nothing to sign out of, just a retry.
 */
export function BetaFull() {
  const [status, setStatus] = useState<"idle" | "redirecting">("idle");
  const [error, setError] = useState("");

  if (session.value) return <Redirect to="/ask" />;

  async function retry() {
    if (status === "redirecting") return;
    setStatus("redirecting");
    setError("");
    dismissAuthError();
    try {
      await signInWithProvider("google");
    } catch (err) {
      setStatus("idle");
      setError(err instanceof Error ? err.message : "Could not start sign-in.");
    }
  }

  return (
    <div class="view">
      <div class="view__center login content">
        <div class="login__card">
          <div class="login__brand">
            <Wordmark />
            <h1 class="login__title">
              FaB Judge is in <em>closed beta</em>.
            </h1>
            <p class="login__subtitle">
              Every seat is taken right now, so new accounts are paused.
            </p>
          </div>

          <div class="login__form">
            <div class="betafull__actions">
              <button
                type="button"
                class="btn btn--primary"
                onClick={retry}
                disabled={status === "redirecting"}
              >
                {status === "redirecting"
                  ? "Redirecting…"
                  : "Try signing in again"}
              </button>
            </div>

            <p class="login__hint">
              Already have an account? The cap only applies to new sign-ups.
            </p>
            {error && (
              <p class="login__hint" role="alert">
                {error}
              </p>
            )}
          </div>
        </div>
        <Disclaimer />
      </div>
    </div>
  );
}
